// Import Packages
import React, {useEffect, useRef, useState} from 'react';
import {useTranslation} from "react-i18next";
import {useSetRecoilState, useRecoilValue} from 'recoil';

// Import Material UI
import {Button, Grid, Tab} from '@material-ui/core';
import StorageIcon from '@material-ui/icons/Storage';
import StoreIcon from '@material-ui/icons/Store';

// Import Pages
import CustomAutoms from "./automList/CustomAutoms";
import InstalledAutoms from "./automList/InstalledAutoms";
import AddNewAutom from "./addNewAutoms/AddNewAutom";
import AutomService from "../../../services/AutomService/AutomService";
import Search from "../../../components/Search/Search";
import CustomizeView from "../../../components/DataTable/CustomizeView/CustomizeView";
import ChooseAutom from './chooseAutom';
import Filters from "../../../components/DataTable/Filters/Filters";
import DeleteConfirm from '../../../components/DataTable/DeleteConfirm';
import {alertState, rolePermission, licensePermission} from '../../../recoil-store/recoil-state';
import {StyledTabs} from "../../../components/FlowConfigurationInputs";

let deletedAutoms = [];
let setSelectedAutomRow;
const AutomList = (props) => {
    const {t} = useTranslation();
    const [customColumn, setCustomColumn] = useState([])
    const [data, setData] = useState([]);
    const [searchData, setSearchData] = useState([])
    const [refresh, setRefresh] = useState(false);
    const [openFilters, setOpenFilters] = useState(false);
    const [openCustomizeView, setOpenCustomizeView] = useState(false);
    const [chooseBot, setChooseBot] = useState(false);
    const [openDelete, setOpenDelete] = useState(false);
    const [loading, setLoading] = useState(false); // default true
    const [open, setOpen] = useState(false);
    const activeAutoms = useRef([]);
    const [loadingDelete, setLoadingDelete] = useState(false);
    const [dataLoading, setDataLoading] = useState(false);
    const setAlert = useSetRecoilState(alertState);
    const permissions = useRecoilValue(rolePermission);
    const license = useRecoilValue(licensePermission);
    const [tab, setTab] = useState(0);

    useEffect(() => {
        async function fetchData() {
            const response = await AutomService.getAutomNameList();
            if (response?.status) {
                if (Array.isArray(response?.data)) {
                    activeAutoms.current = response.data.filter(x => x.status === 1);
                    if (license?.data.no_of_rpa_bots < activeAutoms.current.length) {
                        setChooseBot(true);
                    }
                }
            }
        }

        fetchData().then(r => r);
    }, []);

    useEffect(() => {
        async function fetchData() {
            setLoading(true);
            const response = await AutomService.getAllAutoms('', tab);
            if (response?.status) {
                setDataLoading(true);
                if (response?.status) {
                    if (Array.isArray(response?.data)) {
                        setData(response.data);
                        setSearchData(response.data);
                        activeAutoms.current = response.data.filter(x => x.status === 1);
                        if (license?.data.no_of_rpa_bots < activeAutoms.current.length) {
                            setChooseBot(true);
                        }
                    } else {
                        setData([]);
                        setSearchData([])
                    }
                }

            }
            setLoading(false);
        }

        fetchData().then(r => r);
    }, [refresh]);


    const tabChange = (event, newValue) => {
        let queryParam = {};
        // switch (newValue) {
        //     case 0:
        //         queryParam = { is: 1, environment_target: 'local' };
        //         setFilter({ ...filter, queryParam })
        //         setColumnList(["id", "status", "libraryName", "vendor", "activeVersion", "lastVersion", "modifiedDate", "actions"]);
        //         break;
        //     case 1:
        //         queryParam = { is: 0, i: 0, environment_target: 'global' };
        //         setFilter({ ...filter, queryParam })
        //         setColumnList(["id", "status", "libraryName", "vendor", "lastVersion", "modifiedDate", "actions"]);
        //         break;
        //     case 2:
        //         queryParam = { is: 0, i: 1, environment_target: 'local' };
        //         setFilter({ ...filter, queryParam })
        //         setColumnList(["id", "status", "libraryName", "vendor", "activeVersion", "lastVersion", "modifiedDate", "actions"]);
        //         break;
        //     case 3:
        //         queryParam = { is: 0, m: 1, environment_target: 'local' };
        //         setFilter({ ...filter, queryParam })
        //         setColumnList(["id", "status", "libraryName", "vendor", "devVersion", "activeVersion", "lastVersion", "modifiedDate", "actions"]);
        //         break;
        // }

        setSearchData([]);
        setTab(newValue);
        setRefresh(!refresh);
    };

    const handleRowsDelete = (rowsDeleted, dataArray, setSelectedRows) => {
        if (permissions?.data.includes('CUSTOMAUTOMS_DELETE')) {
            setOpenDelete(true);
            deletedAutoms = [];
            for (let i of rowsDeleted.data) {
                deletedAutoms.push(searchData[i.dataIndex].id);
            }
            setSelectedAutomRow = setSelectedRows;
        } else {
            setAlert(alert => ({
                ...alert,
                show: true,
                message: t("MESSAGES.AUTH-PAGES.RESET-PAGE.HASH-IS-NOT-PROVIDED"),
                severity: 'error'
            }))
        }
    };


    function handleOpen(open, setState) {
        setState(!open);
    }

    const deleteAutoms = async () => {
        let ids = deletedAutoms;
        setLoadingDelete(true);
        const response = await AutomService.deleteAutoms(ids);
        if (response) {
            setAlert(alert => ({
                ...alert,
                show: true,
                message: t(`MESSAGES.AUTOMS.${response.message}`),
                severity: response.status ? 'success' : 'error'
            }))
            if (response.status) {
                setSelectedAutomRow([]);
                setRefresh(!refresh);
            }
        } else {
            setAlert(alert => ({...alert, show: true, message: t('GENERAL.NETWORK-ERROR'), severity: 'error'}))
        }
        setLoadingDelete(false);
    };
    const handleStatusChange = async (e, id) => {
        const res = await AutomService.changeAutomsStatus({status: e.target.checked, ids: [id]});
        if (res?.status) {
            setRefresh(!refresh);
        }
    }

    const handleClick = () => {
        setOpen(!open);
    };

    return (
        <div id="credential-container">
            <Search data={data} setSearchData={setSearchData} xs={11} sm={11} md={11} lg={4} xl={4} spacing={2}
                    searchKey={['name', 'description', 'type', 'updated_at', 'created_by_fullname', 'created_at']}>
                <Grid item xs={12} sm={12} md={8} lg={8} xl={8}>
                    {(tab === 0 && permissions?.data.includes('CUSTOMAUTOMS_CREATE') && dataLoading &&
                        license?.data?.flow_designer &&
                        license?.data.no_of_rpa_bots > activeAutoms.current.length) && (
                        <Button onClick={handleClick} className="searchbar-button">New Autom</Button>)}
                    <Button className="searchbar-button"
                            onClick={() => handleOpen(openCustomizeView, setOpenCustomizeView)}>{t('CONTENT.DATATABLE.TOOLBAR.CUSTOMIZE-VIEW')}</Button>
                    <Button className="searchbar-button"
                            onClick={() => handleOpen(openFilters, setOpenFilters)}>{t('CONTENT.DATATABLE.TOOLBAR.FILTERS')}</Button>
                </Grid>
            </Search>
            <div>
                <StyledTabs value={tab} onChange={tabChange}>
                    <Tab label={t('CONTENT.AUTOMS-LIST.CUSTOM')} value={0} icon={<StorageIcon/>}
                         style={{minWidth: "140px"}}/>
                    <Tab label={t('CONTENT.AUTOMS-LIST.INSTALLED')} value={1} icon={<StoreIcon/>}
                         style={{minWidth: "140px"}}/>
                </StyledTabs>
            </div>

            {
                tab === 0 ? (
                    <CustomAutoms loading={loading} customColumn={customColumn}
                                  handleRowsDelete={handleRowsDelete} handleStatusChange={handleStatusChange}
                                  loadingDelete={loadingDelete} searchData={searchData}
                                  setCustomColumn={setCustomColumn}
                                  activeAutomLen={activeAutoms?.current?.length}
                                  botLimit={license?.data?.no_of_rpa_bots}/>
                ) : (
                    <InstalledAutoms loading={loading} customColumn={customColumn}
                                     data={data} handleRowsDelete={handleRowsDelete}
                                     handleStatusChange={handleStatusChange}
                                     loadingDelete={loadingDelete} searchData={searchData}
                                     setCustomColumn={setCustomColumn}
                                     setData={setData} setSearchData={setSearchData}
                                     activeAutomLen={activeAutoms?.current?.length}
                                     botLimit={license?.data?.no_of_rpa_bots}/>
                )
            }
            {open && <AddNewAutom setOpen={setOpen}/>}

            {openCustomizeView && <CustomizeView setOpen={setOpenCustomizeView} customColumn={customColumn}
                                                 setCustomColumn={setCustomColumn}/>}
            {openFilters &&
            <Filters setOpen={setOpenFilters} customColumn={customColumn} setCustomColumn={setCustomColumn}/>}
            {openDelete &&
            <DeleteConfirm setOpenDelete={setOpenDelete} message={t("CONTENT.AUTOMS-LIST.DELETE-WARNING")}
                           deleteFunc={deleteAutoms}/>}
            {chooseBot && <ChooseAutom data={activeAutoms.current}
                                       setRefresh={setRefresh} setOpen={setChooseBot}
                                       count={license?.data.no_of_rpa_bots}/>
            }

        </div>
    );
};

export default AutomList;
